import { CustomYup } from 'validations/CustomYup'

const manualAssignUserSchema = CustomYup.object().shape({
  user: CustomYup.object({
    id: CustomYup.string().required(),
  }).required(),
})

export default manualAssignUserSchema
